/**
 * Capa de configuración centralizada del dashboard.
 * Todas las variables de entorno se leen aquí y se exportan como constantes tipadas.
 * Nunca leer import.meta.env directamente fuera de este archivo.
 */

/** Nombre de la aplicación, se muestra en sidebar y cabeceras */
export const APP_NAME = import.meta.env.VITE_APP_NAME ?? 'FlowEstudio'

/** Entorno activo: development | staging | production */
export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT ?? 'development'

/** URL base del API backend */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8000'

/** URL pública del dashboard (útil para OAuth callbacks, emails, meta tags) */
export const DASHBOARD_URL = import.meta.env.VITE_DASHBOARD_URL ?? 'http://localhost:5174'

/** URL de la landing pública */
export const LANDING_URL = import.meta.env.VITE_LANDING_URL ?? 'http://localhost:5173'

/** Ruta de login dentro del dashboard */
export const LOGIN_PATH = import.meta.env.VITE_LOGIN_PATH ?? '/login'

/** Ruta de registro dentro del dashboard */
export const SIGNUP_PATH = import.meta.env.VITE_SIGNUP_PATH ?? '/signup'

/** Ruta a la que se redirige tras un login exitoso */
export const DEFAULT_AFTER_LOGIN = import.meta.env.VITE_DEFAULT_AFTER_LOGIN ?? '/'

/** Email de soporte visible al usuario cuando sea necesario */
export const SUPPORT_EMAIL = import.meta.env.VITE_SUPPORT_EMAIL ?? 'soporte@flowestudio.com'

/** Número de WhatsApp de soporte (solo dígitos, formato wa.me) */
export const SUPPORT_WHATSAPP = import.meta.env.VITE_SUPPORT_WHATSAPP as string | undefined

/** App ID de la Meta App, requerido para Embedded Signup (WhatsApp Business) */
export const META_APP_ID = import.meta.env.VITE_META_APP_ID as string | undefined

/** Configuration ID del flujo Embedded Signup en Meta App Dashboard → WhatsApp → Embedded Signup */
export const META_CONFIG_ID = import.meta.env.VITE_META_CONFIG_ID as string | undefined

// ─── Sentry (monitoreo de errores) ───────────────────────────────────────────

/** DSN de Sentry. Si está vacío, Sentry no se inicializa. */
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined

/**
 * Identificador de release para Sentry.
 * Inyectar en CI con el commit SHA: VITE_SENTRY_RELEASE=$(git rev-parse --short HEAD)
 * Permite vincular errores a deploys específicos en la UI de Sentry.
 */
export const SENTRY_RELEASE = import.meta.env.VITE_SENTRY_RELEASE as string | undefined

// ─── Stripe ───────────────────────────────────────────────────────────────────

/**
 * Clave publicable de Stripe (pk_live_… o pk_test_…).
 * Solo para el frontend — nunca usar la secret key en el cliente.
 */
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined

// ─── Pusher (WebSocket / realtime) ───────────────────────────────────────────

/** Clave pública de la app Pusher Channels (App Keys → key) */
export const PUSHER_APP_KEY = import.meta.env.VITE_PUSHER_APP_KEY as string | undefined

/** Cluster de Pusher (ej. mt1, eu, ap1) */
export const PUSHER_APP_CLUSTER = import.meta.env.VITE_PUSHER_APP_CLUSTER ?? 'mt1'
